<template>
    <v-dialog max-width="80%" v-model="dialog">
        <template v-slot:activator={on}>
            <v-btn text icon v-on=on>
                <v-icon small>mdi-pencil</v-icon>
            </v-btn>
        </template>
        <v-card :loading="loading">
            <v-card-title>Add Warehouse</v-card-title>
            <v-card-text>
                <v-alert v-if="errors.length > 0" type="error">
                    <p v-for="(error,idx) in errors" :key="'_err_'+idx">{{error}}</p>
                </v-alert>
                <v-form ref="addForm">
                    <v-select :items="warehouses" item-text="name" item-value="id" v-model="model.warehouse_id" label="Warehouse" :rules="[rules.required]" />
                    <v-select :items="locations" item-text="location" item-value="id" v-model="model.parent_id" label="Parent" />
                    <v-text-field v-model="model.location" label="Location" :rules="[rules.required]" />
                    <v-checkbox v-model="model.container" label="Container ?" />
                    <v-checkbox v-model="model.backstockLocation" label="Backstock ?" />
                    <v-checkbox v-model="model.reserveLocation" label="Reserve ?" />
                    <v-checkbox v-model="model.default" label="Default" />
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="dialog=false">Cancel</v-btn>
                <v-spacer />
                <v-btn @click="save" color="primary">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    data: () => ({
        dialog:null,
        rules: {
            required: value => !!value || "This field is mandatory.",
        },
        loading:false,
        errors:[],
        warehouses:[],
        locations:[]
    }),
    props:{
        location:{
            type:Object,
            required:true
        }
    },
    computed:{
        model(){
            return this.location
        }
    },
    mounted(){
        
    },
    watch:{
        dialog(val){
            if(val){
                this.getWarehouses()
                .then(({warehouses}) => {
                    this.warehouses = warehouses.data
                })
                this.getLocations({filters:{warehouse_id:this.location.warehouse_id}})
                .then(({locations}) => {
                    this.locations = locations.data
                })
            }
        }
    },
    methods:{
        ...mapActions("warehouseLocation", {getLocations:"list",update:"update"}),
        ...mapActions("warehouse", {getWarehouses:"list"}),
        save(){
            this.errors=[]
            if (this.$refs.addForm.validate()) {
                this.loading=true
                this.update(this.model)
                .then(() => {
                    this.$emit("saved")
                    this.dialog=false
                })
                .catch(({data}) => {
                    for (const error of Object.entries(data.errors)) {
                        this.errors.push(error[1][0])
                    }
                })
                .finally(() => {
                    this.loading=false
                })
            }
        }
    }
}
</script>

<style>

</style>